export const DA_FEEDBACK_TABLE_COLUMNS = [
  { id: "title", label: "Title" },
  { id: "desc", label: "Description" },
  { id: "date", label: "Date" },
  { id: "status", label: "" },
];
